import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Box, Typography } from "@mui/material";
import { surface } from "../../../../../theme/muiTheme";

const HistoryDetail = ({ alarm }) => {
  const { t } = useTranslation("common");
  const [language, setLanguage] = useState(
    localStorage.getItem("language") || "en"
  );

  return (
    <Box sx={{ m: "15px" }}>
      <Typography variant="h6" sx={{ fontSize: "18px" }}>
        {t("Details")} -  {alarm.alarmId}
      </Typography>
      <Box sx={{ display: "flex", flexDirection: "row" }}>
        <Box
          component="textarea"
          defaultValue={
            alarm && language === "fi"
              ? alarm.descriptionFI
              : alarm.descriptionEN
          }
          sx={{
            resize: "none",
            bgcolor: surface.panel,
            border: "none",
            width: "100%",
            borderRadius: "4px",
            p: "10px",
            flex: 4,
            height: "80px",
            color: "common.white",
            fontSize: "16px",
          }}
        />
      </Box>
    </Box>
  );
};



export default HistoryDetail;
